import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=08c93020&scoped=true"
import script from "./AppContent.vue?vue&type=script&lang=js"
export * from "./AppContent.vue?vue&type=script&lang=js"
import style0 from "./AppContent.vue?vue&type=style&index=0&id=08c93020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c93020",
  null
  
)

export default component.exports